/*
 * Utils for changing screens ('steps') on the donate/ticketing forms
 *
 * HTML: <div id="js-step-[STEP_NAME]" class="js-step collapse [show]" data-step="[STEP_NAME]" data-enabled="[true|false]">
 * Buttons: <button type="button" class="js-next-step"> and <button type="button" class="js-prev-step">
 */

// Global variable, used for enabling browser's back button
let isSettingHash = false;

export default class Steps {
	constructor() {
		this.steps = $('.js-step');

		this.resetHash();

		$(window).bind('hashchange', this.onHashChanged.bind(this));
	}

	getEnabled() {
		return this.steps.filter(":not([data-enabled='false'])");
	}

	getFirst() {
		return this.steps.first().data('step');
	}

	getCurrent() {
		return $('.js-step.show').data('step') || 0;
	}

	getNext() {
		const steps = this.getEnabled();
		return $(steps[this.getPosition(this.getCurrent()) + 1]).data('step');
	}

	getPrev() {
		const steps = this.getEnabled();
		return $(steps[this.getPosition(this.getCurrent()) - 1]).data('step');
	}

	getPosition(stepName) {
		const targetStep = $("#js-step-" + stepName);
		return this.getEnabled().index(targetStep);
	}

	goToStep(newStep, viaHashChange) {
		const currentStep = this.getCurrent();

		console.log("Steps.goToStep()", currentStep, newStep)

		if(currentStep == newStep) return;

		$('#js-step-' + currentStep).collapse('hide');
		$('#js-step-' + newStep).collapse('show');

		this.scrollToTop();

		if(viaHashChange) return;

		isSettingHash = true;
		window.location.hash = newStep;
	}

	toggleStepVisibility(stepName, isEnabled) {
		$('#js-step-' + stepName).attr("data-enabled", isEnabled);
	}

	resetHash() {
		const windowLocation = window.location;

		if(windowLocation.hash != this.getCurrent()){
			history.pushState("", document.title, windowLocation.pathname + windowLocation.search + '#' + this.getCurrent());
		}
	}

	getHash(url) {
		return typeof url != 'undefined' ? (url.includes("#") ? url.substring(url.indexOf('#') + 1) : this.getFirst()) : -1;
	}

	onHashChanged(e) {
		// If we are setting the hash (through form buttons), we don't run this
		if(isSettingHash){
			isSettingHash = false;
			return;
		}

		const newUrl = e.originalEvent.newURL;

		const oldHash = this.getCurrent();
		const newHash = this.getHash(newUrl);

		const oldHashPosition = this.getPosition(oldHash);
		const newHashPosition = this.getPosition(newHash);

		console.log("Steps.onHashChanged", `URL hash has changed from ${oldHash} (${oldHashPosition}) to ${newHash} (${newHashPosition})`);

		if(newHashPosition != oldHashPosition && (newHashPosition + oldHashPosition) > -1) {
			const currentStep = $('.js-step.show');
			const btn = currentStep.find(newHashPosition < oldHashPosition ? '.js-prev-step' : '.js-next-step');

			// If no buttons, we're on the success/failure screen - reload if going back as allows them to go back to start
			if(!btn.length) {
				window.location.reload();
				return;
			}

			btn.trigger('click');
			isSettingHash = false;
		}
	}

	scrollToTop() {
		const mainElement = $('main');
		const relativePosition = mainElement[0].getBoundingClientRect();

		// Don't scroll to top if already close to top (top 33% of screen)
		if(relativePosition.top > 0 && relativePosition.top < ($(window).height() / 3)) return;

		$("html, body").animate({scrollTop: mainElement.offset().top}, "slow");
	}
}